import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "selectAll"]

  connect() {
    this.updateSelectAll()
  }

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.checkboxTargets.forEach((cb) => (cb.checked = checked))
  }

  updateSelectAll() {
    const total = this.checkboxTargets.length
    const checked = this.checkboxTargets.filter((cb) => cb.checked).length
    this.selectAllTarget.checked = total > 0 && checked === total
    this.selectAllTarget.indeterminate = checked > 0 && checked < total
  }
}
